<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <li :class="readOnly ? 'opacity-50 cursor-not-allowed' : ''"
          class="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow">
    <div class="flex w-full items-center justify-between space-x-6 p-6">
      <div class="flex-1 truncate">
        <div class="flex items-center space-x-3">
          <span class="truncate text-sm font-medium text-gray-900">{{ group.GroupName }}</span>
<!--          <span class="inline-block flex-shrink-0 rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800">{{ group.GroupDescription }}</span>-->
        </div>
        <p class="mt-1 truncate text-sm text-gray-500">{{ group.GroupDescription }}</p>
      </div>
    </div>
    <div>
      <div class="-mt-px flex divide-x divide-gray-200">
        <div class="flex w-0 flex-1">
          <a :class="[alarmsEnabled ? 'text-green-800 hover:text-green-500 bg-green-100' : 'text-gray-800 hover:text-gray-500', readOnly ? 'cursor-not-allowed' : 'cursor-pointer']"
            class="plain-link relative -mr-px inline-flex w-0 flex-1 items-center justify-center rounded-bl-lg border border-transparent py-4 text-sm font-medium"
             @click="setAlarmStatus(true)"
          >
            <span :class="alarmsEnabled ? 'text-green-800' : 'text-gray-400'"
              class="h-5 w-5 lnr icon-alarm-ringing" aria-hidden="true" />
            <span :class="alarmsEnabled ? 'text-green-800' : 'text-gray-400'" class="ml-3">Alarms Enabled</span>
          </a>
        </div>
        <div class="-ml-px flex w-0 flex-1">
          <a :class="[!alarmsEnabled ? 'text-blue-800 hover:text-blue-500 bg-blue-100' : 'text-gray-800 hover:text-gray-500', readOnly ? 'cursor-not-allowed' : 'cursor-pointer']"
             class="plain-link relative inline-flex w-0 flex-1 items-center justify-center rounded-br-lg border border-transparent py-4 text-sm font-medium"
             @click="setAlarmStatus(false)"
          >
            <span :class="!alarmsEnabled ? 'text-blue-800' : 'text-gray-400'"
                  class="h-5 w-5 lnr icon-mute" aria-hidden="true" />
            <span :class="!alarmsEnabled ? 'text-blue-800' : 'text-gray-400'" class="ml-3">Alarms Disabled</span>
          </a>
        </div>
      </div>
    </div>
    <input type="hidden" :name="inputName" :value="alarmsEnabled" />
  </li>
</template>

<script>
export default {
  name: "AlarmSettingsEditGroupsCard",
  props: {
    group: {
      type: Object,
      required: true,
    },
    alarmsEnabledProp: {
      type: Boolean,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      alarmsEnabled: false,
    }
  },
  mounted() {
    this.alarmsEnabled = this.alarmsEnabledProp;
  },
  methods:{
    setAlarmStatus(enabled){
      if (this.readOnly) {
        return
      }
      this.alarmsEnabled = enabled;
      this.$emit('update:alarmStatus', enabled);
    }
  },
  computed:{
    inputName(){
      return 'groupAlarmsEnabled[' + this.group.ID + ']';
    }
  }
}
</script>

<style scoped>

</style>